var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "contrast",
      attrs: {
        width: "80%",
        visible: _vm.visible,
        "before-close": _vm.cancel,
        "close-on-click-modal": false,
        title: _vm.$t("Message.PortAreaDataComparison")
      },
      on: {
        "update:visible": function($event) {
          _vm.visible = $event
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "harbour-data-compare" },
        [
          _c(
            "div",
            { staticClass: "harbour-compare-tit" },
            [
              _vm._v(_vm._s(_vm.$t("Message.Explain"))),
              _c("font", { staticClass: "none" }, [
                _vm._v(_vm._s(_vm.$t("Message.BlackIsTheInputData")))
              ]),
              _c("font", { staticClass: "blue" }, [
                _vm._v(_vm._s(_vm.$t("Message.BlueThePortAreaData")))
              ]),
              _c("p", [
                _vm._v(
                  _vm._s(_vm.$t("Message.ClickEnteredDataPleaseOperation"))
                )
              ])
            ],
            1
          ),
          _c(
            "el-table",
            {
              ref: "multipleTable",
              attrs: {
                data: _vm.tableList,
                height: "300px",
                border: "",
                "span-method": _vm.objectSpanMethod
              },
              on: {
                "cell-mouse-enter": _vm.hoverRow,
                "cell-mouse-leave": _vm.leaveRow,
                "selection-change": _vm.handleSelect
              }
            },
            [
              _c("el-table-column", {
                attrs: {
                  type: "selection",
                  selectable: _vm.selectable,
                  width: "55"
                }
              }),
              _c(
                "el-table-column",
                {
                  attrs: {
                    prop: "type",
                    width: "110",
                    label: _vm.$t("Message.ImportMode")
                  }
                },
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("Message.ImportMode")))
                      ]),
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            placement: "right-start",
                            content: _vm.$t("queryJob.ImportMode")
                          }
                        },
                        [
                          _c("i", {
                            staticClass: "el-icon-question",
                            staticStyle: {
                              color: "#1989fa",
                              "font-size": "18px"
                            }
                          })
                        ]
                      )
                    ],
                    1
                  )
                ],
                2
              ),
              _c("el-table-column", {
                attrs: {
                  prop: "soNo",
                  label: _vm.$t("SeaExport.SoNo"),
                  width: "160"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "span",
                          { class: scope.row.form === "G" ? "blue" : "none" },
                          [_vm._v(_vm._s(scope.row.soNo))]
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "eqSize",
                  label: _vm.$t("SeaExport.ContainerSize"),
                  width: "60"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "span",
                          { class: scope.row.form === "G" ? "blue" : "none" },
                          [_vm._v(_vm._s(scope.row.eqSize))]
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "eqType",
                  label: _vm.$t("SeaExport.ContainerType"),
                  width: "60"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "span",
                          { class: scope.row.form === "G" ? "blue" : "none" },
                          [_vm._v(_vm._s(_vm.mappingEqType(scope.row)))]
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "source",
                  label: _vm.$t("queryJob.DataSource"),
                  width: "120"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "span",
                          { class: scope.row.form === "G" ? "blue" : "none" },
                          [
                            _vm._v(
                              _vm._s(
                                scope.row.source === 1
                                  ? _vm.$t("queryJob.SystemInput")
                                  : _vm.$t("queryJob.PortAreaData")
                              )
                            )
                          ]
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "containerNo",
                  label: _vm.$t("Payment.containerNo"),
                  width: "120"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "span",
                          { class: scope.row.form === "G" ? "blue" : "none" },
                          [_vm._v(_vm._s(scope.row.containerNo))]
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "sealNo",
                  label: _vm.$t("SeaExport.SealNo"),
                  width: "120"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "span",
                          { class: scope.row.form === "G" ? "blue" : "none" },
                          [_vm._v(_vm._s(scope.row.sealNo))]
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "quantity",
                  label: _vm.$t("SeaExport.Quantity"),
                  width: "60"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "span",
                          { class: scope.row.form === "G" ? "blue" : "none" },
                          [
                            _vm._v(
                              _vm._s(
                                scope.row.hasOwnProperty("showQuantity")
                                  ? scope.row.showQuantity
                                  : scope.row.quantity
                              )
                            )
                          ]
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "weight",
                  label: _vm.$t("SeaExport.Weight"),
                  width: "80"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "span",
                          { class: scope.row.form === "G" ? "blue" : "none" },
                          [
                            _vm._v(
                              _vm._s(
                                scope.row.hasOwnProperty("showWeight")
                                  ? scope.row.showWeight
                                  : scope.row.weight
                              )
                            )
                          ]
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "cubage",
                  label: _vm.$t("SeaExport.Cubage"),
                  width: "80"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "span",
                          { class: scope.row.form === "G" ? "blue" : "none" },
                          [
                            _vm._v(
                              _vm._s(
                                scope.row.hasOwnProperty("showCubage")
                                  ? scope.row.showCubage
                                  : scope.row.cubage
                              )
                            )
                          ]
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { disabled: !_vm.isEdit, type: "primary" },
              on: { click: _vm.sumbitHarbour }
            },
            [_vm._v(_vm._s(_vm.$t("queryJob.UpdateToPortAreaData")))]
          ),
          _c("el-button", { on: { click: _vm.cancel } }, [
            _vm._v(_vm._s(_vm.$t("Message.Cancel2")))
          ])
        ],
        1
      ),
      _c("transition", { attrs: { name: "el-fade-in-linear" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.rightShow,
                expression: "rightShow"
              }
            ],
            staticClass: "floating"
          },
          _vm._l(_vm.detailData, function(item, index) {
            return _c("div", { key: index, staticClass: "mar-tp" }, [
              _c("span", [_vm._v(_vm._s(item.soNo) + ": ")]),
              _c("div", { staticStyle: { "margin-left": "10px" } }, [
                _c("span", [_vm._v("件数：" + _vm._s(item.quantity))]),
                _c("span", [_vm._v("毛重：" + _vm._s(item.weight))]),
                _c("span", [_vm._v("体积：" + _vm._s(item.cubage))])
              ])
            ])
          }),
          0
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }